<div class="loader" *ngIf="_isLoading">
  <sui-loader></sui-loader>
</div>
<ng-container *ngIf="!_isLoading">
  <div class="list-header">
    <div class="left">
      <div class="title" *ngIf="isMine">
        이 그룹책에 남긴 <span class="count">{{ _items.length }}</span
        >건의 댓글이 있습니다.
      </div>
      <div class="title" *ngIf="!isMine">
        <b>{{ memberName }}님</b>이 이 그룹책에 남긴
        <span class="count">{{ _items.length }}</span
        >개의 댓글이 있습니다.
      </div>
    </div>
    <div class="right" *ngIf="isMine">
      <button
        class="select-all-button"
        [class.is-active]="
          _selectedItemCount > 0 && _selectedItemCount === _items.length
        "
        (click)="_onSelectAllButtonClick()"
      >
        전체 선택
      </button>
      <select
        sui-select
        [(ngModel)]="_selectedSortType"
        (ngModelChange)="_onSortTypeChange()"
      >
        <option *ngFor="let sortType of _sortTypes" [value]="sortType">
          {{ sortType }}
        </option>
      </select>
    </div>
  </div>
  <div
    class="list"
    #listContainer
    [class.selection-mode]="_selectedItemCount > 0"
  >
    <div class="no-comments" *ngIf="_items.length === 0">
      <div class="no-comments-text">
        <p class="no-comments-text-title">
          아직 이 그룹책에 남긴 댓글이 없습니다.
        </p>
      </div>
    </div>
    <div
      class="list-item"
      *ngFor="let item of _items; index as i"
      [class.is-selected]="item.selected"
    >
      <viewer-icon-checkbox
        *ngIf="isMine"
        class="checkbox"
        [class.is-selected]="item.selected"
        ><input
          type="checkbox"
          [(ngModel)]="item.selected"
          (ngModelChange)="_onItemSelectionChange()"
      /></viewer-icon-checkbox>
      <viewer-reading-mode-memo
        class="memo"
        [memo]="item"
        [text]="item.text"
        [isUnread]="!item.is_read"
        [isOwnedByUser]="isOwnedByUser"
        (memoDeleted)="_onMemoDeleted(item)"
        (memoUpdated)="_onMemoUpdated(item, $event)"
        (replyCommentClick)="_onReplyCommentClick($event)"
        (subReplyCommentChanged)="_onSubReplyCommentChanged($event)"
        [limitHeight]="_shouldLimitHeight(item)"
      ></viewer-reading-mode-memo>
    </div>
  </div>
  <div class="bottom-menu" [class.is-active]="_selectedItemCount > 0">
    <div class="selection-count">
      총 <span>{{ _selectedItemCount }}</span
      >개 선택
    </div>
    <div class="buttons">
      <button
        class="select-cancel-button"
        sui-box-button
        varSize="medium48::medium40::medium40"
        (click)="_onClickSelectCancelButton()"
      >
        선택취소</button
      ><button
        sui-solid-button
        varSize="medium48::medium40::medium40"
        (click)="_onDeleteSelectedItemsButtonClick()"
      >
        삭제하기
      </button>
    </div>
  </div>
</ng-container>

<div
  class="mobile-input-form"
  #mobileInputForm
  [class.is-active]="isCommentInputValid"
>
  <div
    class="comment-input-notification-popup"
    *ngIf="isCommentInputNotificationActive"
  >
    <span>
      <span class="viewer-text">
        {{ _selectedComment?.author.nickname }}
      </span>
      님에게 답글 다는 중
    </span>
    <sui-icon
      name="엑스"
      (click)="_onCloseCommentInputNotification($event)"
    ></sui-icon>
  </div>
  <div class="input-area">
    <div
      class="nickname-indent"
      #nicknameElement
      *ngIf="
        _isReplyCommentInputOpen && _getMentionTarget() && isCommentInputValid
      "
    >
      &commat;{{ _getMentionTarget()?.nickname }}
    </div>
    <textarea
      rows="1"
      #mobileCommentInput
      [readonly]="!isCommentInputValid"
      [placeholder]="
        !isCommentInputValid
          ? '본문을 드래그 후 \'댓글\' 메뉴를 선택하면 댓글을 입력할 수 있습니다'
          : ''
      "
      [(ngModel)]="commentInputValue"
      [style.text-indent]="isCommentInputValid ? _getNicknameIndent() : '0px'"
      (scroll)="_onTextareaScroll($event)"
      (keydown.arrowup)="_onTextareaArrowKey($event)"
      (keydown.arrowdown)="_onTextareaArrowKey($event)"
      (keydown.arrowleft)="_onTextareaArrowKey($event)"
      (keydown.arrowright)="_onTextareaArrowKey($event)"
      (keydown)="_onTextareaKeyDown($event)"
      (input)="_onCommentInputChange()"
    ></textarea>
  </div>

  <div
    class="input-submit-buttons"
    [class.is-active]="isCommentInputValid"
    (click)="_onMobileCommentInputSubmit()"
  >
    <sui-icon name="왼쪽 이동"></sui-icon>
  </div>
</div>
